export type CancelOrderResult =
  | { status: 'ok' }
  | { status: 'error'; error: 'cancel_tickets_feature_missing' | 'cancel_tickets_invalid_email' | 'cancel_tickets_invalid_order_id' | 'cancel_tickets_order_not_found' | 'cancel_tickets_price_is_above_zero' | 'cancel_tickets_not_authorized' | 'cancel_tickets_already_refunded' | 'cancel_tickets_already_cancelled' | string };

export async function cancelOrder(email: string, orderId: string): Promise<CancelOrderResult> {
  const params = new URLSearchParams({ email, order_id: orderId });

  try {
    const response = await fetch(`/of2/public_services/cancel_tickets?${params.toString()}`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
      },
    });
    
    const data = await response.json();
    return data as CancelOrderResult;
  } catch (error) {
    console.error('Error making the request:', error);
    return { status: 'error', error: 'cancel_tickets_generic' };
  }
}
